var chunkMapping = {
	"6179": [
		62797,
		75228,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		99709
	],
	"7293": [
		"default",
		"./AppLoader",
		99709
	],
	"17418": [
		"default",
		"./appSlice",
		99709
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		99709
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		99709
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		99709
	],
	"49394": [
		"default",
		"./store",
		99709
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		99709
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		99709
	],
	"75228": [
		"default",
		"./utils/constants",
		99709
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		99709
	],
	"85646": [
		"default",
		"./headerSlice",
		99709
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		99709
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		99709
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		99709
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 99709
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}